import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qaqkkgrsemzkzjgpsjkv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFhcWtrZ3JzZW16a3pqZ3Bzamt2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjczODU3NDcsImV4cCI6MjA4Mjk2MTc0N30.2eCALVJqTJcsagwOwpkFZRBaFGkk3N1ZYN0Zt3FhUdY";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
